
// Source:
// https://stackoverflow.com/questions/10420352/converting-file-size-in-bytes-to-human-readable-string/10420404
export const getFileSize = function getReadableFileSizeString(fileSizeInBytes) {
    var i = -1;
    var byteUnits = [' kB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
    do {
        fileSizeInBytes = fileSizeInBytes / 1024;
        i++;
    } while (fileSizeInBytes > 1024);

    return Math.max(fileSizeInBytes, 0.1).toFixed(1) + byteUnits[i];
};

export const FileExtType = {
    Unknown: 'doc',
    Audio: 'audio',
    Image: 'image',
    Model: 'model',
    Text: 'text',
    Video: 'video',
    Svg: 'svg',
    Docx: 'docx',
    Pptx: 'pptx',
    Xlsx: 'xlsx',
    Doc: 'doc',
    Png: 'png',
    Jpg: 'jpg',
};

export const FileCode = {
    application: FileExtType.Unknown,
    audio: FileExtType.Audio,
    image: FileExtType.Image,
    model: FileExtType.Model,
    text:  FileExtType.Text,
    video: FileExtType.Video,
    // Custom
    'svg+xml': FileExtType.Svg,
    svg: FileExtType.Svg,
    docx: FileExtType.Docx,
    pptx: FileExtType.Pptx,
    xlsx: FileExtType.Xlsx,
    doc: FileExtType.Doc,
    png: FileExtType.Png,
    jpg: FileExtType.Jpg,
    jpeg: FileExtType.Jpg,
};

export const getFileExtension = (rawFileName) => {
    const fileName = String(rawFileName);
    const fileExtPos = fileName.lastIndexOf('.');
    if (fileExtPos > 0) {
        return fileName.slice(fileExtPos + 1);
    }
    return null;
}

export const getFileFormatDetails = function getFileFormatDetails(mimeType, ext) {
    const mtypes = String(mimeType).toLowerCase().split('/');
    const fallback = (type) => {
        return FileCode[type];
    };
    const obj = {
        main: fallback(mtypes[0]),
        detailed: fallback(mtypes[1]),
        extension: fallback(String(ext).toLowerCase())
    };
    obj.guessed = obj.extension || obj.detailed || obj.main;
    return obj;
};